import { useMemo } from 'react'

export type OS = 'mac' | 'windows' | 'linux' | 'unknown'

export function useOS(): OS {
  return useMemo(() => {
    if (typeof navigator === 'undefined') return 'unknown'

    const platform = navigator.platform?.toLowerCase() || ''
    const userAgent = navigator.userAgent?.toLowerCase() || ''

    if (platform.includes('mac') || userAgent.includes('mac')) {
      return 'mac'
    }
    if (platform.includes('win') || userAgent.includes('win')) {
      return 'windows'
    }
    if (platform.includes('linux') || userAgent.includes('linux')) {
      return 'linux'
    }

    return 'unknown'
  }, [])
}

export function useModifierKey(): { key: string; symbol: string } {
  const os = useOS()

  return useMemo(() => {
    if (os === 'mac') {
      return { key: 'meta', symbol: '\u2318' } // Command symbol
    }
    return { key: 'ctrl', symbol: 'Ctrl' }
  }, [os])
}

export function getModifierSymbol(): string {
  if (typeof navigator === 'undefined') return 'Ctrl'

  const platform = navigator.platform?.toLowerCase() || ''
  const userAgent = navigator.userAgent?.toLowerCase() || ''

  if (platform.includes('mac') || userAgent.includes('mac')) {
    return '\u2318'
  }
  return 'Ctrl'
}
